export default new (class AudioNotification {
  constructor() {
    this._audio = new Audio();
    this._audio.addEventListener('ended', () => {
      this._audio.src = '';
    });
    // window.play = this;
  }

  _play({ src, volume }) {
    this._audio.src = src;
    this._audio.volume = volume;
    const promise = this._audio.play();

    if (promise) {
      promise.catch((ignore) => {});
    }
  }

  generic() {
    this._play({
      src: '//dp4stoslb9jdl.cloudfront.net/Resources/studio/audio/ding.mp3',
      volume: 1,
    });
  }

  capture() {
    this._play({
      src: '/resources/sound/capture.mp3',
      volume: 0.15,
    });
  }

  insertOverlayToScene() {
    this._play({
      src: '/resources/sound/scene2.mp3',
      volume: 0.7,
    });
  }
})();
